<script lang="ts">

    import {tweened} from "svelte/motion";
    import {cubicOut} from "svelte/easing";


    export let current: number | null;
    export let label: string = '';
    export let withShadow: boolean = false;
    export let compactMode: boolean = false;

    const currentTweened = tweened(0, {
        duration: 300,
        easing: cubicOut,
        interpolate: (a, b) => (t) => b > a ? a + t * (b-a) : b
    });

    $: currentTweened.set(current!==null ? current : 0);

</script>


<div class="container-progress-bar">
    {#if !compactMode}
        <div class="progress-bar-label">{label} {current !== null ? Math.floor($currentTweened)+'%' : ''}</div>
    {/if}
    <div class="progress-bar-container" style={current===null ? "filter: grayscale(1)" : ""}>
        <div class="background"></div>
        <div class="foreground" style="width:{current!==null ? Math.min(Math.max($currentTweened,0),100) : 0}%"></div>
        {#if current!==null && current>0 && withShadow}
            <div class="foreground-shadow" style="width:{$currentTweened}%"></div>
        {/if}
        {#if compactMode}
            <div class="percent-inside">{current!==null ? `${Math.floor($currentTweened)}%` : ``}</div>
        {/if}
    </div>
</div>


<style>
    :root {
        --barHeight: 20px;
        --radius: 3px;
        --barBackground: #dcf1c6;
        --barForeground: #b9e493;
    }
    .container-progress-bar {
        margin: 9px 0;
        min-width: 100px;
        width: 100%;
    }
    .progress-bar-label {
        font-size:14px;
    }
    .progress-bar-container {
        width:100%;
        margin:2px 0;
        position: relative;
    }
    .background {
        width:100%;
        height: var(--barHeight);
        background-color: var(--barBackground);
        border-radius: var(--radius);
    }
    .foreground {
        top:0;
        position: absolute;
        width:100%;
        height: var(--barHeight);
        background-color: var(--barForeground);
        border-radius: var(--radius);
    }
    .percent-inside {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }

</style>